import AWS from 'aws-sdk';
import accountService from 'services/account';
import { v4 as uuid } from 'uuid';
import { lowercaseExtension } from './helper';

const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
const AWS_REGION = process.env.REACT_APP_AWS_REGION;
const AWS_IDENTITY_POOL_ID = process.env.REACT_APP_AWS_IDENTITY_POOL_ID;

const tokenCache = new Map(); // Cache to store tokens per account

// Fetch or return cached account token
const getCachedAccountToken = async (ownerAccountId) => {
    const cachedToken = tokenCache.get(ownerAccountId);

    if (cachedToken && cachedToken.expiresAt > Date.now()) {
        return cachedToken;
    }

    const accountTokens = await accountService.getAccountTokens(ownerAccountId);
    const tokenExpiryTime = Date.now() + 10 * 60 * 1000; // Cognito developer token defaults to 15 minutes

    tokenCache.set(ownerAccountId, {
        IdentityId: accountTokens.IdentityId,
        Token: accountTokens.Token,
        expiresAt: tokenExpiryTime,
    });

    return accountTokens;
};

// Fetch or return cached AWS credentials
let cachedCredentials = null;
const getAwsCredentials = async (identityId) => {
    if (cachedCredentials?.identityId === identityId && !cachedCredentials.credentials.needsRefresh()) {
        return cachedCredentials.credentials;
    }

    const accountTokens = await getCachedAccountToken(identityId);
    const credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: AWS_IDENTITY_POOL_ID,
        IdentityId: accountTokens.IdentityId,
        Logins: { 'cognito-identity.amazonaws.com': accountTokens.Token },
    });

    await credentials.getPromise(); // Ensure credentials are ready
    cachedCredentials = { identityId, credentials };
    return credentials;
};

// Upload a file to S3
const uploadFile = async (file, onProgress, onSuccess, onError, accountId) => {
    try {
        AWS.config.update({ region: AWS_REGION });

        const credentials = await getAwsCredentials(accountId);
        AWS.config.update({ credentials });

        const s3 = new AWS.S3();
        const key = uuid();

        s3.upload(
            {
                Bucket: S3_BUCKET,
                Key: `${key}/${lowercaseExtension(file.name)}`,
                Body: file,
                ContentType: file.type,
            },
            (err) => {
                if (err) {
                    return onError(err);
                }
                onSuccess({ bucket: S3_BUCKET, key, type: file.type, name: lowercaseExtension(file.name) });
            }
        ).on('httpUploadProgress', (p) => onProgress({ percent: (p.loaded / p.total) * 100 }));
    } catch (err) {
        onError(err);
    }
};

export { uploadFile };
